import { useTranslation } from 'react-i18next';

interface PreviewContext {
  contextId: string;
  periodForever?: boolean;
  periodStartDate?: string | null;
  periodEndDate?: string | null;
  periodInstant?: string | null;
}

interface ClonePreview {
  tagCount: number;
  unitCount: number;
  contexts: PreviewContext[];
}

const StepCarries = ({ preview }: { preview: ClonePreview }) => {
  const { t } = useTranslation('roll-forward');

  return (
    <div className="roll-forward__step">
      <h4 className="roll-forward__heading">{t('step.carries')}</h4>
      <ul className="roll-forward__counts">
        <li>
          <strong>{preview.tagCount}</strong> {t('count.tags')}
        </li>
        <li>
          <strong>{preview.contexts.length}</strong> {t('count.contexts')}
        </li>
        <li>
          <strong>{preview.unitCount}</strong> {t('count.units')}
        </li>
      </ul>
      <p className="roll-forward__not-cloned text-gray-500">{t('not-cloned')}</p>
      <p className="roll-forward__reset-hint">
        <i className="fa-regular fa-circle-info mr-1" /> {t('reset-hint')}
      </p>
    </div>
  );
};

export default StepCarries;
